import { Injectable } from '@angular/core';
import { DocumentsEnum } from '../../models/enums/typeDocuments.enum';
import { Share } from '@capacitor/share';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, Observable, take } from 'rxjs';
import { Documents } from '../../models/documents.model';
import * as qs from 'qs';
import { APIResponse, Data, StrapiFile, UserContract } from '@mlc/types';
import { ClientDocuments } from '../../models/clientDocuments';
import { Filesystem, Directory, DownloadFileResult } from '@capacitor/filesystem';
import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';
import { PlatformEnum } from '../../models/enums/platform.enum';
import { SilentErrorsEnum } from '../../models/enums/SilentErrors.enum';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private httpClient: HttpClient){}

  getDocuments(documentsType: DocumentsEnum[], userId: number, productWallet: UserContract & {id: number;}): Observable<ClientDocuments> {
    const query: string = qs.stringify(
      {
        filters: {
          type: {
            $in: documentsType
          },
        },
        populate: {
          file: { fields: ["url", "ext", "name"] }
        },
        sort: ['date:desc']
      },
      { encode: false }
    );
    return this.httpClient
      .get<APIResponse<Data<Documents>[]>>(`${environment.baseUrl}/users/${userId}/products/${productWallet.id}/documents?${query}`)
      .pipe(
        take(1),
        map((document: APIResponse<Data<Documents>[]>): ClientDocuments => ({
          productName: productWallet.product.name,
          documents: document.data,
        }))
      )
  }

  async shareDocument(userFile: StrapiFile): Promise<void> {
    if(Capacitor.getPlatform() === PlatformEnum.WEB) {
      const url: string = userFile.url;
      Browser.open({ url });
    } else {
      const file: DownloadFileResult = await Filesystem.downloadFile({
        path: `${userFile.name}${userFile.ext}`,
        url: userFile.url,
        directory: Directory.Cache
      });

      Share.share({
        title: userFile.name,
        url: `file://${file.path}`,
      }).catch((error) => {
        if (error?.message?.includes(SilentErrorsEnum.SHARE_CANCELED)) {
          return;
        }
      });
    }
  }

  uploadFile(formData: FormData) {    
    return this.httpClient.post<StrapiFile[]>(`${environment.baseUrl}/upload`, formData).pipe(
      take(1)
    );
  }

  createDocument(type: DocumentsEnum, fileId: string, userProductWalletId: number) {
    const document = {
      data: {
        file: fileId,
        type: type,
        clientProductWallet: userProductWalletId
      }
    }

    return this.httpClient.post<APIResponse<Data<Documents>>>(`${environment.baseUrl}/documents`, document).pipe(
      take(1)
    );
  }
}
